module.exports = __webpack_public_path__ + "assets/img/22_241_big.05537c4e.jpg";